import type { Deal } from '@/types'

type DealListState = {
  deals: Deal[]
  selectedDeal: Deal | null
}

/** Atualiza um deal na lista e no painel selecionado (evita closure stale). */
export function patchDealInState(
  state: DealListState,
  id: string,
  updates: Partial<Deal> | Deal,
): Partial<DealListState> {
  const nextDeal =
    'id' in updates && updates.id === id
      ? (updates as Deal)
      : null

  const deals = state.deals.map((d) => {
    if (d.id !== id) return d
    return nextDeal ?? { ...d, ...updates }
  })

  const selectedDeal =
    state.selectedDeal?.id === id
      ? nextDeal ?? { ...state.selectedDeal, ...updates }
      : state.selectedDeal

  return { deals, selectedDeal }
}

export function removeDealFromState(state: DealListState, id: string): Partial<DealListState> {
  return {
    deals: state.deals.filter((d) => d.id !== id),
    selectedDeal: state.selectedDeal?.id === id ? null : state.selectedDeal,
  }
}

export function appendDealIfMissing(state: DealListState, deal: Deal): Partial<DealListState> {
  if (state.deals.some((d) => d.id === deal.id)) {
    return patchDealInState(state, deal.id, deal)
  }
  return { deals: [...state.deals, deal] }
}

/** Anexa deals de outra página sem duplicar IDs. */
export function mergeDealsPages(existing: Deal[], incoming: Deal[]): Deal[] {
  return incoming.reduce((acc, deal) => {
    const next = appendDealIfMissing({ deals: acc, selectedDeal: null }, deal)
    return next.deals ?? acc
  }, existing)
}
